const U = "?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const IMG = {
  hero: "https://static.prod-images.emergentagent.com/jobs/bde4a810-44c3-42ca-b19e-990ce4920c18/images/2654c05017ccbfd097e68c1c19f11400ea84a15bf1ab550ab56e21d9a62d013f.jpeg",
  bespoke: "https://static.prod-images.emergentagent.com/jobs/bde4a810-44c3-42ca-b19e-990ce4920c18/images/400d820d083700b29b783f4b6a2d40569e60157ad7ab4bed0991350c42f5e4c9.jpeg",
};

const CHESS = "https://images.unsplash.com/photo-1736349294738-b602054ccf50" + U;
const PLANTER = "https://images.unsplash.com/photo-1617214922084-5db8d3c3df5a" + U;
const DIFFUSER = "https://images.unsplash.com/photo-1778784544843-712029254a98" + U;
const CANDLE = "https://images.unsplash.com/photo-1765031117402-93b2e530edec" + U;
const TUMBLER = "https://images.unsplash.com/photo-1767536196118-9f0592594dcc" + U;
const VASE = "https://images.unsplash.com/photo-1643569556871-91ec60671ed7" + U;
const TABLEWARE = "https://images.unsplash.com/photo-1616671285410-2a676a9a433d" + U;
const GIFTBOX = "https://images.unsplash.com/photo-1760804876166-aae5861ec7c1" + U;
const AMENITY = "https://images.unsplash.com/photo-1669123700531-3941fe4f3ba4" + U;
const NAPKIN = "https://images.unsplash.com/photo-1591625591034-75d303d2e1a4" + U;
const OPENER = "https://images.unsplash.com/photo-1592925316685-b62484d491f3" + U;
const POTPOURRI = "https://images.unsplash.com/photo-1701266379865-2a79ad6a6c71" + U;
const TOTE = "https://images.unsplash.com/photo-1544816155-12df9643f363" + U;
const BOARD = "https://images.unsplash.com/photo-1784901391293-5a9c098bba43" + U;
const MATCHBOX = "https://images.unsplash.com/photo-1731686830802-9aa081988796" + U;
const COASTER = "https://static.prod-images.emergentagent.com/jobs/bde4a810-44c3-42ca-b19e-990ce4920c18/images/400d820d083700b29b783f4b6a2d40569e60157ad7ab4bed0991350c42f5e4c9.jpeg";
const APRON = "https://static.prod-images.emergentagent.com/jobs/bde4a810-44c3-42ca-b19e-990ce4920c18/images/0b5ef630fa27bab7650dd235725c7b466e4413de274889729f8b433062a890fd.jpeg";

export const COLLECTIONS = [
  { name: "Decor Objects", tag: "Trays · Openers · Boards", img: BOARD },
  { name: "Candles & Scent", tag: "Candles · Diffusers · Sachets", img: DIFFUSER },
  { name: "Branded Gifting", tag: "Boxes · Totes · Matches", img: GIFTBOX },
  { name: "Textiles & Aprons", tag: "Napkins · Aprons · Coasters", img: APRON },
  { name: "Planters & Botanics", tag: "Vessels · Pots · Stands", img: PLANTER },
  { name: "Chess & Games", tag: "Boards · Backgammon · Cards", img: CHESS },
  { name: "Tableware & Ceramics", tag: "Vases · Plates · Servingware", img: TABLEWARE },
  { name: "Barware", tag: "Openers · Coasters · Stirrers", img: TUMBLER },
];

export const PRODUCTS = [
  { id: "p1", name: "Olive Wood Serving Board", range: "Decor Objects", moq: "MOQ 50", img: BOARD },
  { id: "p2", name: "Brass Bottle Opener", range: "Decor Objects", moq: "MOQ 100", img: OPENER },
  { id: "p3", name: "Embossed Leather Coaster", range: "Textiles & Aprons", moq: "MOQ 100", img: COASTER },
  { id: "p4", name: "Linen Napkin Set", range: "Textiles & Aprons", moq: "MOQ 100", img: NAPKIN },
  { id: "p5", name: "Amber Scented Candle", range: "Candles & Scent", moq: "MOQ 100", img: CANDLE },
  { id: "p6", name: "Reed Diffuser", range: "Candles & Scent", moq: "MOQ 100", img: DIFFUSER },
  { id: "p7", name: "Scent Sachet & Potpourri", range: "Candles & Scent", moq: "MOQ 200", img: POTPOURRI },
  { id: "p8", name: "Signature Gift Box", range: "Branded Gifting", moq: "MOQ 100", img: GIFTBOX },
  { id: "p9", name: "Kraft Matchbox Set", range: "Branded Gifting", moq: "MOQ 250", img: MATCHBOX },
  { id: "p10", name: "Cotton Tote Bag", range: "Branded Gifting", moq: "MOQ 200", img: TOTE },
  { id: "p11", name: "Guest Amenity Set", range: "Branded Gifting", moq: "MOQ 250", img: AMENITY },
  { id: "p12", name: "Terra Ribbed Planter", range: "Planters & Botanics", moq: "MOQ 50", img: PLANTER },
  { id: "p13", name: "Waxed Canvas Apron", range: "Textiles & Aprons", moq: "MOQ 50", img: APRON },
  { id: "p14", name: "Nero Marble Chess Set", range: "Chess & Games", moq: "MOQ 20", img: CHESS },
  { id: "p15", name: "Halo Ceramic Vase", range: "Tableware & Ceramics", moq: "MOQ 40", img: VASE },
];

export const QUALITY = [
  { icon: "Medal", title: "Hospitality-grade quality", desc: "Materials and finishes specified for daily service, stress-tested to survive the busiest rooms." },
  { icon: "UsersThree", title: "A dedicated account team", desc: "One point of contact from brief to delivery — across every location in your estate." },
  { icon: "Stack", title: "Volume made simple", desc: "From boutique runs to multi-site rollouts, with consistent quality at any scale." },
  { icon: "Truck", title: "Delivered anywhere", desc: "Coordinated logistics to a single venue or an entire group, on schedule, every time." },
];

export const PARTNER = [
  { n: "01", title: "Consult", desc: "We learn your brand, theme, volumes and timelines." },
  { n: "02", title: "Curate", desc: "We propose a tailored selection from our ranges." },
  { n: "03", title: "Sample", desc: "Prototypes and finishes approved before any run." },
  { n: "04", title: "Produce", desc: "Made to spec with rigorous quality control." },
  { n: "05", title: "Deliver", desc: "Shipped and installed to every location on time." },
];

export const CLIENTS = ["Hotel Groups", "Restaurant Collections", "Corporate Workspaces", "Members' Clubs", "Luxury Resorts", "Fine Dining"];
